/* De La Terre · Home below-the-fold assets v1.1 · P1.26.0 performance */
(function () {
  'use strict';

  if (window.__DLT_HOME_BELOW_FOLD_V1__) return;
  window.__DLT_HOME_BELOW_FOLD_V1__ = true;

  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var saveData = !!(connection && connection.saveData);
  var slowConnection = !!(connection && /(^|-)2g$/.test(connection.effectiveType || ''));
  var ROOT_MARGIN = (saveData || slowConnection) ? '420px 0px' : '850px 0px';

  /*
    P1.26.0 — reduz prefetch excessivamente antecipado.
    1400px fazia várias sections abaixo da dobra hidratarem logo após o
    DOMContentLoaded em telas mobile. 850px mantém folga para scroll normal,
    enquanto conexões lentas/Save-Data usam 420px para poupar rede e main thread.
  */
  var observer = null;
  var stylePromises = Object.create(null);
  var scriptPromises = Object.create(null);

  function absoluteUrl(url) {
    try { return new URL(url, document.baseURI).href; } catch (e) { return url || ''; }
  }

  function findStyle(url) {
    var target = absoluteUrl(url);
    return Array.prototype.find.call(document.querySelectorAll('link[rel="stylesheet"]'), function (link) {
      return absoluteUrl(link.href) === target;
    });
  }

  function loadStyle(url) {
    if (!url) return Promise.resolve();
    var key = absoluteUrl(url);
    if (stylePromises[key]) return stylePromises[key];

    var existing = findStyle(key);
    if (existing) {
      stylePromises[key] = Promise.resolve(existing);
      return stylePromises[key];
    }

    stylePromises[key] = new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = key;
      link.dataset.dltHomeLazyStyle = 'true';
      link.onload = function () { resolve(link); };
      link.onerror = function () { reject(new Error('DLT home CSS failed: ' + key)); };
      document.head.appendChild(link);
    });

    return stylePromises[key];
  }

  function findScript(url) {
    var target = absoluteUrl(url);
    return Array.prototype.find.call(document.scripts, function (script) {
      return script.src && absoluteUrl(script.src) === target;
    });
  }

  function loadScript(url) {
    if (!url) return Promise.resolve();
    var key = absoluteUrl(url);
    if (scriptPromises[key]) return scriptPromises[key];

    var existing = findScript(key);
    if (existing) {
      scriptPromises[key] = Promise.resolve(existing);
      return scriptPromises[key];
    }

    scriptPromises[key] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = key;
      script.async = true;
      script.dataset.dltHomeLazyScript = 'true';
      script.onload = function () { resolve(script); };
      script.onerror = function () { reject(new Error('DLT home JS failed: ' + key)); };
      document.head.appendChild(script);
    });

    return scriptPromises[key];
  }

  function hydrate(section) {
    if (!section || section.dataset.dltHomeAssetsState === 'ready' || section.dataset.dltHomeAssetsState === 'loading') return;
    section.dataset.dltHomeAssetsState = 'loading';

    var css = section.dataset.dltHomeCss || '';
    var js = section.dataset.dltHomeJs || '';

    loadStyle(css)
      .catch(function () { /* keep functional fallback */ })
      .then(function () { return loadScript(js); })
      .catch(function () { /* section remains readable without enhancement */ })
      .then(function () {
        section.dataset.dltHomeAssetsState = 'ready';
      });
  }

  function ensureObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        hydrate(entry.target);
      });
    }, { root: null, rootMargin: ROOT_MARGIN, threshold: 0.01 });
    return observer;
  }

  function schedule(section) {
    if (!section || section.dataset.dltHomeAssetsState) return;
    if ((window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) {
      hydrate(section);
      return;
    }
    ensureObserver().observe(section);
  }

  function scan(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var items = Array.prototype.slice.call(context.querySelectorAll('[data-dlt-home-lazy-assets]'));
    if (context.matches && context.matches('[data-dlt-home-lazy-assets]')) items.unshift(context);
    items.forEach(schedule);
  }

  function hydrateFromIntent(event) {
    var target = event.target && event.target.closest ? event.target.closest('[data-dlt-home-lazy-assets]') : null;
    if (!target) return;
    if (observer) observer.unobserve(target);
    hydrate(target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('pointerdown', hydrateFromIntent, { passive: true, capture: true });
  document.addEventListener('focusin', hydrateFromIntent, true);

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
